import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TokenStorage {
  private readonly TOKEN_STORAGE_KEY = 'token';

  get(): string | null {
    return localStorage.getItem(this.TOKEN_STORAGE_KEY);
  }

  set(t: string): void {
    localStorage.setItem(this.TOKEN_STORAGE_KEY, t);
  }

  clear(): void {
    localStorage.removeItem(this.TOKEN_STORAGE_KEY);
  }

  has(): boolean {
    return !!this.get();
  }
}
